const EyeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.99988 8.00008C8.99988 8.55236 8.55217 9.00008 7.99988 9.00008C7.4476 9.00008 6.99988 8.55236 6.99988 8.00008C6.99988 7.44779 7.4476 7.00008 7.99988 7.00008C8.55217 7.00008 8.99988 7.44779 8.99988 8.00008Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.81988 3.33341C11.8065 3.21341 14.1532 6.92674 14.5799 7.66674C14.699 7.87301 14.699 8.12714 14.5799 8.33341C14.0065 9.33341 11.8665 12.5734 8.17988 12.6667H8.01322C4.08655 12.6667 1.83988 9.06008 1.41988 8.33341C1.30079 8.12714 1.30079 7.87301 1.41988 7.66674C1.99988 6.66674 4.13322 3.42674 7.81988 3.33341ZM5.66655 8.00008C5.66655 9.28874 6.71122 10.3334 7.99988 10.3334C9.28855 10.3334 10.3332 9.28874 10.3332 8.00008C10.3332 6.71141 9.28855 5.66674 7.99988 5.66674C6.71122 5.66674 5.66655 6.71141 5.66655 8.00008Z"
      fill="currentColor"
    />
  </svg>
);

export default EyeIcon;
